// import {createClient} from '@sanity/client'

// const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || 'rk2tuy9i'
// const dataset = process.env.REACT_APP_SANITY_DATASET || 'production'

// const client = createClient({
//   projectId,
//   dataset,
//   apiVersion: '2026-05-16',
//   useCdn: true,
// })

// export default client


import {createClient, type SanityClient} from '@sanity/client'

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID || 'rk2tuy9i'
const dataset = process.env.REACT_APP_SANITY_DATASET || 'production'

const client: SanityClient = createClient({
  projectId,
  dataset,
  apiVersion: '2026-05-16',
  useCdn: true,
})

export default client
